import { useEffect } from 'react';

// Auto Resizes text area on change to scrollHeight
export const useAutoResizeTextarea = (
  textareaRef: React.RefObject<HTMLTextAreaElement>,
) =>
  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + 'px';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textareaRef?.current?.scrollHeight]);
